<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :product-id="productId"
            :runtimes="runtimes"
            :runtime-default="runtimeDefault"
            :market-regions="marketRegions"
            :target-options="targetOptions"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/ProductPlans/Form'

export default {
    name: 'ProductPlanCreate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        productId: {
            type: Number,
            default: 0
        },
        runtimes: {
            type: Array,
            default () {
                return []
            }
        },
        runtimeDefault: {
            type: String,
            default () {
                return ''
            }
        },
        marketRegions: {
            type: Array,
            default () {
                return []
            }
        },
        targetOptions: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(
                this.$route('products.products.plans.store', { product: this.productId })
            )
        }
    }
}
</script>
